import {SelectEnum} from "../model";

export function searchTypeList() {
  return [
    new SelectEnum("近期热点数据", "yuliao"),
    new SelectEnum("历史全部数据", "naotu")
  ]
}

